import { motion } from "framer-motion";
import { images } from "../../constants";

import { AppWrap, MotionWrap } from "../../wrapper";
import "./About.scss";

// import { urlFor, client } from '../../client';

const abouts = [
  {
    title: "AWS DevOps",
    description: "Python Docker Jenkins Kubernetes Terraform Linux AWS",
    imgUrl: images.about01,
  },
  {
    title: "Frontend Development",
    description: " React Redux Next Typescript Tailwind MUI",
    imgUrl: images.about02,
  },
  {
    title: "Backend Development",
    description: " Express MongoDB SQL REST Graphql",
    imgUrl: images.about03,
  },
  {
    title: "AI Integration",
    description: "Open AI | Deepseek",
    imgUrl: images.about04,
  },
];

function About() {
  return (
    <>
      <h2 className="head-text">
        I know that <span>Good Development</span>
        <br />
        means <span>Goood Business</span>
      </h2>
      <div className="app__profiles">
        {abouts.map((about, index) => (
          <motion.div
            whileInView={{ opacity: 1 }}
            whileHover={{ scale: 1.1 }}
            transition={{ duration: 0.5, type: "tween " }}
            className="app__profile-item"
            key={about.title + index}
          >
            <img src={about.imgUrl} alt={about.title} />
            <h2 className="bold-text" style={{ marginTop: 20 }}>
              {about.title}
            </h2>
            <p className="p-text" style={{ marginTop: 10 }}>
              {about.description}
            </p>
          </motion.div>
        ))}
      </div>
    </>
  );
}
export default AppWrap(
  MotionWrap(About, "app__about"),
  "about",
  "app__whitebg"
);
